import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en';
import { fr } from './fr';
import { frCA } from './fr-CA';

export const KnBrCartBaseTranslations: TranslationResources = {
  en,
  fr,
  fr_CA: frCA,
};

export const KnBrCartBaseTranslationChunksConfig: TranslationChunksConfig = {
  cart: ['cartDetails', 'cartItems', 'orderCost', 'voucher', 'saveForLaterItems', 'clearCart', 'validation'],
};
